export default "__VITE_ASSET__3238c9e6__"